



// sebi





// import React, { Component } from "react";
// import AuthService from "../services/auth.service";


// export default class BoardSebi extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       content: "",
//       letterData: [],
//       selectedRecord: null,
//       dpsohData: [],
//       ledgerData: [],
//       mtfpoData: [],
//       netpoData: [],
//       portfoData: [],
//       nomineeData: [],
//       isViewingRecord: false,
//       hoveredDptype: "",
//       mousePosition: { x: 0, y: 0 },
//       searchValue: "",
//       activeButton: null,
//       dataFound: true,
//     };
//   }

// //   handleHover = (event, dptype) => {
// //     this.setState({
// //       hoveredDptype: dptype,
// //       mousePosition: { x: event.clientX, y: event.clientY },
// //     });
// //   };

// //   handleMouseLeave = () => {
// //     this.setState({ hoveredDptype: "" });
// //   };

//   componentDidMount() {
//     this.getLetterData();
//   }

//   getLetterData = async () => {
//     try {
//       const response = await fetch("http://183.182.84.228:4005/sebi/");
//       const letterData = await response.json();
//       if (letterData.length > 0) {
//         this.setState({ letterData: letterData, dataFound: true });
//       } else {
//         this.setState({ letterData: null, dataFound: false });
//       }
//     } catch (error) {
//       window.alert(`An error occurred: ${error}`);
//     }
//   };
  

//   handleView = async (record) => {
//     this.setState({
//       selectedRecord: record,
//       isViewingRecord: true,
//       dpsohData: [],
//       ledgerData: [],
//       mtfpoData: [],
//       netpoData: [],
//       portfoData: [],
//       nomineeData: [],
//     });
//   };

// //   handleViewDpsoh = async () => {
// //     try {
// //       const currentUser = AuthService.getCurrentUser();
// //       const response = await fetch("http://183.182.84.228:4005/dpsoh/");
// //       const dpsohData = await response.json();
// //       const selectedDpsohData = dpsohData.filter(
// //         (item) => item.kslucc === currentUser.username
// //       );
// //       if (selectedDpsohData.length > 0) {
// //         this.setState({ dpsohData: selectedDpsohData });
// //         this.setState({ activeButton: 'dpsoh' });
// //       } else {
// //         window.alert('Data not found for selected record.');
// //       }
// //     } catch (error) {
// //       window.alert(`An error occurred: ${error}`);
// //     }
// //   };
  




// //   handleExitView = () => {
// //     this.setState({ isViewingRecord: false });
// //   };

// //   handleSearchChange = (event) => {
// //     this.setState({ searchValue: event.target.value }, this.getLetterData);
// //   };

// render() {
//     const {
//       letterData,
//       dataFound
//     } = this.state;
  
//     return (
//       <div className="container">
//         <header className="jumbotron">
//           <h3>{this.state.content}</h3>
//         </header>
  
//         <div>
//           {dataFound ? (
//             letterData && letterData.length > 0 && (
//                 <div>
//                 <table class=" table table-striped table-scroll">
//       <thead>
//         <tr>
//         <th>ClientId</th>
//         <th>cl_name</th>
//         <th>NetBal</th>
//         <th>group_id</th>
//         <th>Location</th>
//         <th>FmlyCount</th>
//         <th>FmlyBal</th>
//         <th>FirstCrBalDt</th>
//         <th>FirstCrBal</th>
//         <th>AsOnDate</th>
//         <th>AsOnBal</th>
//         <th>InitialMarg</th>
//         <th>UnBilledVallanDr</th>
//         <th>NetCr</th>
//         <th>SettlDrBal</th>
//         <th>SettlDate</th>
//         <th>MF</th>
//         <th>Collateral</th>
//         <th>LatestRectPay</th>
//         <th>CashMargin</th>
//         <th>NetReceipt</th>
//         <th>ProvInterest</th>
//         <th>ProvDPCharges</th>
//         <th>BSESTARMFOpeningbalance</th>
//         <th>BSESTARMFSIPdueAmount</th>
//         <th>BSESTARMFNetopeningBalance</th>
//         <th>SharePledge_repledge</th>
//         <th>FO</th>
//         <th>CDS</th>
//         <th>MCX</th>
//         <th>NCDEX</th>
//         <th>Column1</th>
//         <th>RAL</th>
//         <th>locnid</th>
//         </tr>
//       </thead>
//       <tbody>
//       {letterData.map((record, index) => (
//                   <tr key={index}>
//                     <td>{record.ClientId}</td>
//                     <td>{record.cl_name}</td>
//                     <td>{record.NetBal}</td>
//                     <td>{record.group_id}</td>
//                     <td>{record.Location}</td>
//                     <td>{record.FmlyCount}</td>
//                     <td>{record.FmlyBal}</td>
//                     <td>{record.FirstCrBalDt}</td>
//                     <td>{record.FirstCrBal}</td>
//                     <td>{record.AsOnDate}</td>
//                     <td>{record.AsOnBal}</td>
//                     <td>{record.InitialMarg}</td>
//                     <td>{record.UnBilledVallanDr}</td>
//                     <td>{record.NetCr}</td>
//                     <td>{record.SettlDrBal}</td>
//                     <td>{record.SettlDate}</td>
//                     <td>{record.MF}</td>
//                     <td>{record.Collateral}</td>
//                     <td>{record.LatestRectPay}</td>
//                     <td>{record.CashMargin}</td>
//                     <td>{record.NetReceipt}</td>
//                     <td>{record.ProvInterest}</td>
//                     <td>{record.ProvDPCharges}</td>
//                     <td>{record.BSESTARMFOpeningbalance}</td>
//                     <td>{record.BSESTARMFSIPdueAmount}</td>
//                     <td>{record.BSESTARMFNetopeningBalance}</td>
//                     <td>{record.SharePledge_repledge}</td>
//                     <td>{record.FO}</td>
//                     <td>{record.CDS}</td>
//                     <td>{record.MCX}</td>
//                     <td>{record.NCDEX}</td>
//                     <td>{record.Column1}</td>
//                     <td>{record.RAL}</td>
//                     <td>{record.locnid}</td>
//                   </tr>
//                 ))}
//       </tbody>
//     </table>
//     <br/><br/>
//               </div>
//             )
//           ) : (
//             <p>Data is not available in Sebi Payout.</p>
//           )}
//         </div>
//       </div>
//     );
//   }
  
// }




























// sebis








import React, { Component } from "react";
import AuthService from "../services/auth.service";


export default class BoardSebi extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
      letterData: [],
      selectedRecord: null,
      dpsohData: [],
      ledgerData: [],
      mtfpoData: [],
      netpoData: [],
      portfoData: [],
      nomineeData: [],
      isViewingRecord: false,
      hoveredDptype: "",
      mousePosition: { x: 0, y: 0 },
      searchValue: "",
      activeButton: null,
      dataFound: true,
    };
  }

//   handleHover = (event, dptype) => {
//     this.setState({
//       hoveredDptype: dptype,
//       mousePosition: { x: event.clientX, y: event.clientY },
//     });
//   };

//   handleMouseLeave = () => {
//     this.setState({ hoveredDptype: "" });
//   };

  componentDidMount() {
    this.getLetterData();
  }

  getLetterData = async () => {
    try {
      const response = await fetch("http://183.182.84.228:4005/sebis/");
      const letterData = await response.json();
      if (letterData.length > 0) {
        this.setState({ letterData: letterData, dataFound: true });
      } else {
        this.setState({ letterData: null, dataFound: false });
      }
    } catch (error) {
      window.alert(`An error occurred: ${error}`);
    }
  };
  

  handleView = async (record) => {
    this.setState({
      selectedRecord: record,
      isViewingRecord: true,
      dpsohData: [],
      ledgerData: [],
      mtfpoData: [],
      netpoData: [],
      portfoData: [],
      nomineeData: [],
    });
  };

//   handleViewDpsoh = async () => {
//     try {
//       const currentUser = AuthService.getCurrentUser();
//       const response = await fetch("http://183.182.84.228:4005/dpsoh/");
//       const dpsohData = await response.json();
//       const selectedDpsohData = dpsohData.filter(
//         (item) => item.kslucc === currentUser.username
//       );
//       if (selectedDpsohData.length > 0) {
//         this.setState({ dpsohData: selectedDpsohData });
//         this.setState({ activeButton: 'dpsoh' });
//       } else {
//         window.alert('Data not found for selected record.');
//       }
//     } catch (error) {
//       window.alert(`An error occurred: ${error}`);
//     }
//   };
  




//   handleExitView = () => {
//     this.setState({ isViewingRecord: false });
//   };

//   handleSearchChange = (event) => {
//     this.setState({ searchValue: event.target.value }, this.getLetterData);
//   };

render() {
    const {
      letterData,
      dataFound
    } = this.state;
  
    return (
      <div className="container">
        <header className="jumbotron">
          <h3>{this.state.content}</h3>
        </header>
  
        <div>
          {dataFound ? (
            letterData && letterData.length > 0 && (
                <div>
                <table class=" table table-striped table-scroll">
      <thead>
        <tr>
        <th>Selection</th>
        <th>ClientCode</th>
        <th>Client Name</th>
        <th>Opening Date</th>
        <th>Family Code</th>
        <th>Branch Code</th>
        <th>Active</th>
        <th>LAS Client</th>
        <th>UCC Category</th>
        <th>Authorization Type</th>
        <th>Financial Balance</th>
        <th>Adhoc Amount</th>
        <th>Current Balance (A)</th>
        <th>Settement Payout</th>
        <th>Pledge Value</th>
        <th>Collateral Value (A1)</th>
        <th>Securities Value (B)</th>
        <th>Ben Stock Value(B1)</th>
        <th>Accrued Interest</th>
        <th>Total Balance of Funds and Securities on Settlement (C=A+A1+B)</th>
        <th>Derivative Margin Obligation as on Settlement Day EOD(D)</th>
        <th>Cash margin to be retained (50% of EOD Margin)</th>
        <th>Credit margin for previous day</th>
        <th>O/S Settlement Obligation of 2 day cash and 1 day derivatives (E)</th>
        <th>Stock whose Payin Pending (F)</th>
        <th>Turnover in Cash Segment on Settlement Day(G)</th>
        <th>Funds allowed to be retained H=G+F+E+(D+D*125%)</th>
        <th>225 % of EOD margin minus cash margin as computed</th>
        <th>225% of EOD margin to be retained from funds if available after adjusting securities pledged/repledged or commodities</th>
        <th>Amount required to be settled I=C-H</th>
        <th>Securities Settle J=Minimum of (B-F)I</th>
        <th>Funds Settled (K)=(I-J)</th>
        <th>Securities Settled</th>
        <th>Funds Released</th>
        <th>Last Fin. Settle Date</th>
        <th>Last Stk. Settle Date</th>
        <th>Remarks</th>
        <th>Master</th>
        <th>locnid</th>
        </tr>
      </thead>
      <tbody>
      {letterData.map((record, index) => (
                  <tr key={index}>
                    <td>{record.Selection}</td>
                    <td>{record.ClientCode}</td>
                    <td>{record.Client_Name}</td>
                    <td>{record.Opening_Date}</td>
                    <td>{record.Family_Code}</td>
                    <td>{record.Branch_Code}</td>
                    <td>{record.Active}</td>
                    <td>{record.LAS_Client}</td>
                    <td>{record.UCC_Category}</td>
                    <td>{record.Authorization_Type}</td>
                    <td>{record.Financial_Balance}</td>
                    <td>{record.Adhoc_Amount}</td>
                    <td>{record.Current_Balance_A}</td>
                    <td>{record.Settement_Payout}</td>
                    <td>{record.Pledge_Value}</td>
                    <td>{record.Collateral_Value_A1}</td>
                    <td>{record.Securities_Value_B}</td>
                    <td>{record.Ben_Stock_Value_B1}</td>
                    <td>{record.Accrued_Interest}</td>
                    <td>{record.Total_Balance_of_Funds_and_Securities_on_Settlement_C}</td>
                    <td>{record.Derivative_Margin_Obligation_as_on_Settlement_Day_EOD_D}</td>
                    <td>{record.Cash_margin_to_be_retained_50_per_of_EOD_Margin}</td>
                    <td>{record.Credit_margin_for_previous_day}</td>
                    <td>{record.OS_Settlement_Obligation_of_2_day_cash_and_1_day_derivatives_E}</td>
                    <td>{record.Stock_whose_Payin_Pending_F}</td>
                    <td>{record.Turnover_in_Cash_Segment_on_Settlement_Day_G}</td>
                    <td>{record.Funds_allowed_to_be_retained_H}</td>
                    <td>{record.EOD_margin_minus_cash_margin_as_computed_255_per}</td>
                    <td>{record.EOD_margin_to_be_retained_from_funds_if_available_after_255_per}</td>
                    <td>{record.Amount_required_to_be_settled_I}</td>
                    <td>{record.Securities_Settle_J}</td>
                    <td>{record.Funds_Settled_K}</td>
                    <td>{record.Securities_Settled}</td>
                    <td>{record.Funds_Released}</td>
                    <td>{record.Last_Fin_Settle_Date}</td>
                    <td>{record.Last_Stk_Settle_Date}</td>
                    <td>{record.Remarks}</td>
                    <td>{record.Master}</td>
                    <td>{record.locnid}</td>
                  </tr>
                ))}
      </tbody>
    </table>
    <br/><br/>
              </div>
            )
          ) : (
            <p>Data is not available in Sebi Payout.</p>
          )}
        </div>
      </div>
    );
  }
  
}
